import angular from 'angular';

angular.module('cloudX').filter('feature', [
  'checkFeature',
  function(checkFeature) {
    return function(sec) {
      return checkFeature(sec);
    };
  },
]);
